import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../utils/classnames';

const CustomSelect = ({
  disabled = false,
  label,
  name,
  options = [],
  value,
  onChange,
  required,
  placeholder = 'Selecione...',
  labelClassName = 'text-lg font-normal',
  py = 'py-3',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (option) => {
    if (disabled) return;

    if (onChange) {
      onChange({ target: { name, value: option.value } });
    }
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col gap-1 relative" ref={dropdownRef}>
      {label && (
        <label htmlFor={name} className={cn('text-blueDarker', labelClassName)}>
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}

      <div
        className={`relative flex items-center justify-between border border-bluePale rounded-xl px-3 ${py} text-base bg-white select-none ${
          disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2">
          {selectedOption ? (
            <>
              {selectedOption.colorHex && (
                <span
                  style={{ backgroundColor: selectedOption.colorHex }}
                  className="rounded w-3 h-3 block flex-shrink-0"
                />
              )}
              <span className="text-blueDarker truncate">{selectedOption.label}</span>
            </>
          ) : (
            <span className="text-blueSteel">{placeholder}</span>
          )}
        </div>

        <ChevronDown
          size={18}
          className={`text-blueSteel transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          strokeWidth={1.5}
        />
      </div>

      {isOpen && (
        <div className="absolute top-full left-0 w-full mt-1 bg-white border border-bluePale rounded-xl shadow-lg z-50 overflow-hidden max-h-60 overflow-y-auto">
          {options.length > 0 ? (
            options.map((opt, i) => (
              <div
                key={i}
                className={`flex items-center gap-2 px-3 py-3 cursor-pointer hover:bg-grayExtraLight2 transition-colors ${
                  value === opt.value ? 'bg-bluePale/20' : ''
                }`}
                onClick={() => handleSelect(opt)}
              >
                {opt.colorHex && (
                  <span style={{ backgroundColor: opt.colorHex }} className="rounded w-3 h-3 block flex-shrink-0" />
                )}
                <span className="text-blueDarker">{opt.label}</span>
              </div>
            ))
          ) : (
            <div className="px-3 py-3 text-blueSteel text-center text-sm">Nenhuma opção disponível</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
